import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import RadarCorreoLayout from "./RadarCorreoLayout";
import { MENU, RADAR_CORREO_BASE, radarCorreoDefaultRoute } from "./config";

const children: RouteObject[] = [
  { index: true, element: <Navigate to={radarCorreoDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const radarCorreoRoute: RouteObject = {
  path: RADAR_CORREO_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [{ path: "", element: <RadarCorreoLayout />, children }],
};
